import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["click"],
  setup(__props, { emit: emits }: { emit: ({
  (event: "click"): void;
}), expose: any, slots: any, attrs: any }) {



function onCreateTask() {
  emits("click");
}

return { __sfc: true,emits, onCreateTask }
}

})